export const pwa = {
  deferredPrompt: null,
  canInstall: false, // For Chrome/Android/Edge
  isManual:
    /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.userAgent.includes("Macintosh") &&
      navigator.userAgent.includes("Safari") &&
      !navigator.userAgent.includes("Chrome")),
  // Detect if app is currently running as the installed PWA
  isInstalled:
    window.matchMedia("(display-mode: standalone)").matches ||
    window.navigator.standalone === true, // only true in iOS home screen,
  _iosModal: null,

  init() {
    // 1. Capture the Chrome/Android auto-install event
    window.addEventListener("beforeinstallprompt", (e) => {
      e.preventDefault();
      this.deferredPrompt = e;
      this.canInstall = true;
    });

    // 2. Hide button immediately if user installs
    window.addEventListener("appinstalled", () => {
      this.canInstall = false;
      this.isInstalled = true;
    });
  },

  async handleAction() {
    if (this.canInstall && this.deferredPrompt) {
      // Chrome path: Trigger the prompt
      this.deferredPrompt.prompt();
      const { outcome } = await this.deferredPrompt.userChoice;
      if (outcome === "accepted") this.canInstall = false;
      this.deferredPrompt = null;
    } else if (this.isManual) {
      // iOS path: Show your custom Modal/Alert with instructions
      // alert("To install: Tap the 'Share' icon and then 'Add to Home Screen'.");
      // this.showIosInstallInstructionsModal();
    }
  },

  // showIosInstallInstructionsModal() {
  //   if (this._iosModal === null) {
  //     this._iosModal = {};
  //     const el = document.getElementById("iosPWAInstallInstructions");
  //     this._iosModal.iosInstallInstructionsModal = new Modal(el);

  //     const carousel = document.getElementById("carouselExampleCaptions");
  //     this._iosModal.carousel = new Carousel(carousel);
  //   }

  //   this._iosModal.iosInstallInstructionsModal.show();
  // },
};
